export const NotificationStrings = {
  notifiaction: 'Notifications',
  updateError: 'Could not update subscription!',
  manageSubcription: 'Manage subscription by subscribing or unsubscribing',
}
